import React, { useEffect, useId, useState } from 'react';
import ticketService from '../../services/ticketService';
import { getProviderOptionLabel } from './ProviderSelectOption';

const TicketProviderSelect = ({ ticketId, provider, onChange, disabled }) => {
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const id = useId();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(async () => {
      const result = await ticketService.getRequestProviderOptions(ticketId, search.trim());
      if (cancelled) return;
      setLoading(false);
      setError(result.success ? '' : result.message || 'Unable to load target providers.');
      setOptions(result.success ? result.data : []);
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [ticketId, search]);

  const choices = [provider, ...options.filter(option => option._id !== provider?._id)].filter(Boolean);
  return <div className="ticket-request-form">
    <label htmlFor={`${id}-search`}>Search target provider
    <input id={`${id}-search`} className="input" value={search} onChange={event => setSearch(event.target.value)} disabled={disabled} placeholder="Search by provider name or code" /></label>
    <label htmlFor={id}>Target provider *
    <select id={id} className="input" required value={provider?._id || ''} disabled={disabled || loading || !!error}
      onChange={event => onChange(choices.find(option => option._id === event.target.value))}>
      {!provider && <option value="">Select a provider</option>}
      {choices.map(option => <option key={option._id} value={option._id}>{getProviderOptionLabel(option)}{option.code ? ` — ${option.code}` : ''}</option>)}
    </select></label>
    {loading && <span className="ticket-muted" role="status">Loading providers...</span>}
    {error && <span role="alert" className="ticket-inline-notice is-error">{error}</span>}
    <p className="ticket-muted">Changing the target resets Production and Staging to the new provider’s defaults in this draft. Review those values before saving.</p>
  </div>;
};

export default TicketProviderSelect;
